import { render, staticRenderFns } from "./ReservationRegisterTab.vue?vue&type=template&id=0a80c894&scoped=true&lang=pug"
import script from "./ReservationRegisterTab.vue?vue&type=script&lang=ts"
export * from "./ReservationRegisterTab.vue?vue&type=script&lang=ts"
import style0 from "./ReservationRegisterTab.vue?vue&type=style&index=0&id=0a80c894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80c894",
  null
  
)

export default component.exports